import * as z from "zod";

export const checkTeamSession = {
  name: "checkTeamSession" as const,
  input: z.object({}),
  output: z.object({ teamId: z.string(), version: z.number().nullable() }),
};
